import apiAction from "../ajax/service";
import validators from "../dynamicform/validators";
import { setWorkspaceSettings ,setWorkspaceMembers, setWorkspaceRoles, setWebhooks} from "../features/workspaceSlice";
import { loadConfigs } from "./invoiceBuilderInterface";

const getWorkspaceSettings = async (dispatch , id ) =>{
    var data = await apiAction("workspace",{filters:{workspaceId:id}},"get_workspace_config")
    await loadConfigs(dispatch)
    dispatch(setWorkspaceSettings(data))

}


const setWorkspaceConfig = async (dispatch , id , config ) =>{
    var data = await apiAction("workspace",{id , config:JSON.stringify(config) },"set_workspace_config")
    getWorkspaceSettings(dispatch,sessionStorage.getItem('selectedWorkspace'))

}

const createNewWorkspace = async(dispatch ,name , seedData)=>{
    var data = await apiAction("workspace",{name , seedData },"create_workspace")
    return data
}

const generateApiKey = async (dispatch ,workspaceSettingsId, enableApiKey) => {
    const data = await apiAction("workspace",{id:workspaceSettingsId,enableApiKey
    },"generate_api_key")
    dispatch(setWorkspaceSettings(data))

}
const getWorkspaceMembers = async(dispatch , id )=> {
    var data = await apiAction("users",{filters:{workspaceId:id}},"get_workspace_member")
    dispatch(setWorkspaceMembers(data))
}



const addMemberToWorkspace = async (dispatch , workspaceId, email, role) =>{
    if (!validators.validEmail(email)) alert("Not Valid email")
    var data = await apiAction("users",{email , role , filters : { workspaceId}},"create_workspace_member")
    getWorkspaceMembers(dispatch , workspaceId)

}

const setWorkspaceMemberRole = async (dispatch ,workspaceId, email , role) => {
    var data = await apiAction("users",{email , role , filters : { workspaceId}},"update_workspace_member")
    getWorkspaceMembers(dispatch , workspaceId)
}
const deleteWorkspaceMember = async (dispatch ,workspaceId, email ) => {
    var data = await apiAction("users",{email , filters : { workspaceId}},"delete_workspace_member")
    getWorkspaceMembers(dispatch , workspaceId)
}

const manageWebhooks = async(dispatch , body , action)=>{
    const reqBody = {...body}
    var data = await apiAction("workspace",reqBody,action)

    if(action.startsWith("get")){
        dispatch(setWebhooks(data.data))
    }
    if(!action.startsWith("get")){
        manageWebhooks(dispatch,{},'getAll_webhook')
    }

}
const manageWorkspaceRole = async(dispatch , name , roleConfig , action )=>{

    const reqBody = {}
    if (action.startsWith("add") || action.startsWith("update") || action.startsWith("delete") ){
        reqBody['name'] = name
        reqBody['config'] = roleConfig
    }
    // if (action.startsWith("delete")){
    //     reqBody["filters"] = {'name_workspaceId' : {
    //         name : name,
    //         workspaceId:sessionStorage.getItem("selectedWorkspace")
    //     }}
    // }
    var data = await apiAction("users",reqBody,action)
    if(action.startsWith("get")){
        dispatch(setWorkspaceRoles(data))
    }
    else {
        manageWorkspaceRole(dispatch,"","","get_workspace_role")
    }
}

export {createNewWorkspace,manageWebhooks,manageWorkspaceRole,generateApiKey ,getWorkspaceSettings,setWorkspaceConfig,getWorkspaceMembers,addMemberToWorkspace,setWorkspaceMemberRole,deleteWorkspaceMember}
